// removed by extract-text-webpack-plugin
module.exports = {"container":"_2xhCN","message":"_3te3p","title":"_30f3O","content":"_2Z-0_","button":"aWsk5"};


//////////////////
// WEBPACK FOOTER
// ./app/components/share-form/share-form.scss
// module id = 891
// module chunks = 3 4 5 6 7